import { ERROR, MENU, MENU_ITEM_PATCH, MENU_ITEM_REMOVE, START, SUCCESS } from '../../types/action-types'

const initialState = {
  menu: [],
  businessMenu: [],
  loading: false,
  error: null,
}

const patchDish = (dish, menuId, patch) => (dish.id === menuId ? { ...dish, ...patch } : dish)

export const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${MENU}${START}`:
      return { ...state, loading: true, error: null }

    case `${MENU}${SUCCESS}`:
      return {
        ...state,
        loading: false,
        menu: action.payload.menu,
        businessMenu: action.payload.businessMenu,
      }

    case `${MENU}${ERROR}`:
      return { ...state, loading: false, error: action.payload }

    case MENU_ITEM_PATCH: {
      const { menuId, patch } = action.payload

      return {
        ...state,
        menu: state.menu.map(dish => patchDish(dish, menuId, patch)),
        businessMenu: state.businessMenu.map(bl => ({
          ...bl,
          categories: bl.categories.map(category => ({
            ...category,
            menu: category.menu.map(dish => patchDish(dish, menuId, patch)),
          })),
        })),
      }
    }

    case MENU_ITEM_REMOVE: {
      const { menuId, blCategoryId } = action.payload

      // Убрали блюдо из категории бизнес-ланча — трогаем только эту категорию,
      // в обычном меню блюдо остаётся.
      if (blCategoryId != null) {
        return {
          ...state,
          businessMenu: state.businessMenu.map(bl => ({
            ...bl,
            categories: bl.categories.map(category =>
              category.id === blCategoryId ? { ...category, menu: category.menu.filter(dish => dish.id !== menuId) } : category
            ),
          })),
        }
      }

      // Скрыли блюдо из обычной секции — пропадает из меню ресторана.
      // Из составов бизнес-ланчей скрытие не убирает (см. ТЗ), поэтому businessMenu не трогаем.
      return {
        ...state,
        menu: state.menu.filter(dish => dish.id !== menuId),
      }
    }

    default:
      return state
  }
}
